import { useMutation } from "@tanstack/react-query";
import { useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { modalAtom } from "../atoms";
import { patch } from "../axios";
import { DenyReason } from "../utils/uber";
import useOrders from "./useOrders";

interface Props {
  id: number;
  branchId: number;
}
const useUberOrderDeny = ({ id, branchId }: Props) => {
  const { t } = useTranslation();

  const setModalName = useSetAtom(modalAtom);

  const { refetch } = useOrders();

  const mutation = useMutation({
    mutationFn: (body: DenyReason) =>
      patch(
        `/internal/secure/pos/v1/orders/information/status/${branchId}/${id}/rejected`,
        body
      ),
    onSuccess: () => {
      toast.success(t("success.deniedOrder"));
      setModalName("");
      refetch();
    },
    onError: () => {
      toast.error(t("errors.deniedOrder"));
    },
  });
  return mutation;
};
export default useUberOrderDeny;
